var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconListheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ListHeart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5 7C24.5 6.76794 24.4078 6.54538 24.2437 6.38128C24.0796 6.21719 23.8571 6.125 23.625 6.125H4.375C4.14293 6.125 3.92038 6.21719 3.75628 6.38128C3.59219 6.54538 3.5 6.76794 3.5 7C3.5 7.23206 3.59219 7.45462 3.75628 7.61872C3.92038 7.78281 4.14293 7.875 4.375 7.875H23.625C23.8571 7.875 24.0796 7.78281 24.2437 7.61872C24.4078 7.45462 24.5 7.23206 24.5 7ZM23.625 14.875H10.625C10.3929 14.875 10.1704 14.7828 10.0063 14.6187C9.84219 14.4546 9.75 14.2321 9.75 14C9.75 13.7679 9.84219 13.5454 10.0063 13.3813C10.1704 13.2172 10.3929 13.125 10.625 13.125H23.625C23.8571 13.125 24.0796 13.2172 24.2437 13.3813C24.4078 13.5454 24.5 13.7679 24.5 14C24.5 14.2321 24.4078 14.4546 24.2437 14.6187C24.0796 14.7828 23.8571 14.875 23.625 14.875ZM8.875 20.125H23.625C23.8571 20.125 24.0796 20.2172 24.2437 20.3813C24.4078 20.5454 24.5 20.7679 24.5 21C24.5 21.2321 24.4078 21.4546 24.2437 21.6187C24.0796 21.7828 23.8571 21.875 23.625 21.875H8.875C8.64294 21.875 8.42038 21.7828 8.25628 21.6187C8.09219 21.4546 8 21.2321 8 21C8 20.7679 8.09219 20.5454 8.25628 20.3813C8.42038 20.2172 8.64294 20.125 8.875 20.125Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListheart);
export default __webpack_public_path__ + "static/media/icon_listheart.323a2665c34c52f18904ee38f5f4659b.svg";
export { ForwardRef as ReactComponent };